import React, { useCallback } from 'react';
import { Container, Row, Col, Button, Progress } from 'reactstrap';
import './styles.css';
import uploadimg from '../../assets/V2-images/uploadimg.svg';
import close from '../../assets/V2-images/close.svg';
import { useDropzone } from 'react-dropzone';
import { ButtonC } from 'Common/Buttons';
import Dropzone from 'react-dropzone';

function Basic(props) {
  const onDrop = useCallback(
    (acceptedFiles) => {
      const files = Array.isArray(props.files) ? props.files : [];
      props.setFiles([...files, ...acceptedFiles]);
    },
    [props.files, props.setFiles],
  );

  const { getRootProps, getInputProps, open } = useDropzone({
    onDrop,
  });

  const removeFile = (file) => () => {
    const newFiles = [...props.files];
    newFiles.splice(newFiles.indexOf(file), 1);
    props.setFiles(newFiles);
  };

  const removeAll = () => {
    props.setFiles([]);
  };

  const handleDropDocument = (acceptedFiles, index) => {
    props.setFiles((prev) =>
      prev.map((item, i) =>
        i === index
          ? {
              file: item,
              videoThumb: acceptedFiles,
            }
          : item,
      ),
    );
  };
  const files = props?.files
    ? props?.files.map((file, i) => {
        // Get the file object (handle videoThumb case)
        const fileObj = file.videoThumb ? file?.file : file;
        // Format size in MB with 2 decimal places

        const sizeInMB = fileObj?.size ? (fileObj.size / (1024 * 1024)).toFixed(2) : '0.00';
        const fileURL = URL.createObjectURL(fileObj);

        return (
          <tr key={fileObj?.path || i}>
            <td>{i + 1}</td>
            <td>
              <img
                src={fileURL}
                alt={fileObj.name}
                style={{ width: '20px', height: '20px', borderRadius: '50%' }}
              />
            </td>
            <td>{fileObj?.path}</td>
            <td>{fileObj?.type}</td>
            <td>{sizeInMB} MB</td>
            <td className="d-flex justify-content-end gap-4">
              {(fileObj?.type || '').includes('video') && (
                <div>
                  <Dropzone onDrop={(attached) => handleDropDocument(attached, i)} multiple={true}>
                    {({ getRootProps, getInputProps }) => (
                      <div
                        className="filedropzonestyle"
                        {...getRootProps()}
                        style={{
                          background: '#ffffff',
                          border: '1px solid #929292',
                          padding: '2px',
                          borderRadius: '8px',
                        }}
                      >
                        <input {...getInputProps()} />
                        <div>
                          {file?.videoThumb ? file?.videoThumb?.[0]?.path : 'Upload Thumbnail'}
                        </div>
                      </div>
                    )}
                  </Dropzone>
                </div>
              )}
              <img src={close} onClick={removeFile(file)} style={{ cursor: 'pointer' }} />
            </td>
          </tr>
        );
      })
    : [];

  return (
    <div>
      {!props.previewFlag && (
        <div>
          <Row>
            <Col xs="12" lg="12" style={styles.dam_dropbox}>
              <Container
                style={props.disableDropBox ? { pointerEvents: 'none', opacity: '0.4' } : {}}
              >
                <Row>
                  <Col xs="12" md="12" lg="15" className="drop_box h_80_vh">
                    <div
                      {...getRootProps({ className: 'dropzone' })}
                      className={!props.isDropCircle && 'drop_circle1'}
                    >
                      <input {...getInputProps()} />

                      <div style={{ cursor: 'pointer', textAlign: 'center' }}>
                        <img src={uploadimg} />
                        <div className="chosefile">
                          Drag & drop files here or <span> Choose file </span>
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>
              </Container>
            </Col>
            <Col></Col>
          </Row>

          {files.length > 0 && (
            <Row style={props.disableDropBox ? { opacity: '0.4' } : {}}>
              <div className="w-100 d-flex gap-3 justify-content-between mt-5">
                <div
                  style={{
                    width: '100%',
                    display: 'flex',
                    alignItems: 'center',
                  }}
                >
                  Assets To Upload
                </div>
                <div className="w-100 d-flex gap-3 justify-content-end ">
                  <ButtonC text="Close" color="Secondary" size="lg" click={removeAll} />

                  <button
                    onClick={() => {
                      props.uploadFiles();
                    }}
                    className="button cursor-pointer Button-text text-decoration-none large-button Primary-Button"
                  >
                    Upload
                  </button>
                </div>
              </div>
            </Row>
          )}
          {files.length > 0 && (
            <Row
              style={props.disableDropBox ? { pointerEvents: 'none', opacity: '0.4' } : {}}
              className="selected-files-list"
            >
              <table className="table table-striped responsive" style={{ width: '100%' }}>
                <tbody>{files}</tbody>
              </table>
            </Row>
          )}
          <Row className="dam-center">
            {props.uploadPercentage > 0 && `${props.uploadPercentage} %`}
            {props.loadedData > 0 &&
              `${parseFloat(props.loadedData / (1024 * 1024)).toPrecision(4)} MB / ${parseFloat(
                props.totalData / (1024 * 1024),
              ).toPrecision(4)} MB`}
          </Row>

          {props.uploadPercentage > 0 && (
            <Progress style={{ width: '80%', height: '20px' }} value={props.uploadPercentage} />
          )}
        </div>
      )}
    </div>
  );
}

const styles = {
  dam_dropbox: {
    backgroundColor: 'white',
    padding: '2rem',
    borderRadius: '10px',
    border: '1px dashed rgba(146, 146, 146, 1)',
  },
  drop_circle: {
    borderRadius: '50%',
    border: '2px solid black',
    padding: '4rem',
    width: '50%',
    margin: '1rem',
    display: 'flex',
    justifyContent: 'center',
  },
};

export default Basic;
